import script from "./standard-list.vue?vue&type=script&setup=true&lang=js"
export * from "./standard-list.vue?vue&type=script&setup=true&lang=js"

import "./standard-list.vue?vue&type=style&index=0&id=0ac921c7&lang=scss&scoped=true"
import "./standard-list.vue?vue&type=style&index=1&id=0ac921c7&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac921c7"]])

export default __exports__